import React from 'react';
import styled from 'styled-components';
import { Section } from '../styles';
import Fluid from '../../Fluid';

const Card = styled.div`
  background-color: ${({ $backgroundColor, theme }) => theme.palette[$backgroundColor]};
  border-radius: 0.5rem;
`;

const CardSection = ({ children, backgroundColor, padding = 'md' }) => {
  return (
    <Section padding={padding} borderless>
      <Fluid padding="none">
        <Card $backgroundColor={backgroundColor ?? 'backgroundSecondary'}>{children}</Card>
      </Fluid>
    </Section>
  );
};

export default CardSection;
